import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const PrioritizationQueue = ({ leads = [], onContact }) => {
  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high': return 'bg-red-100 text-red-700';
      case 'medium': return 'bg-yellow-100 text-yellow-700';
      default: return 'bg-green-100 text-green-700';
    }
  };

  if (leads?.length === 0) {
    return (
      <div className="bg-card border border-border rounded-lg p-12 text-center">
        <Icon name="Users" size={48} className="text-muted-foreground mx-auto mb-4 opacity-40" />
        <h3 className="text-lg font-semibold text-foreground mb-2">No Leads in Queue</h3>
        <p className="text-muted-foreground">Add leads to see them prioritized here</p>
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-lg shadow-elevation-1 overflow-hidden">
      <div className="p-4 border-b border-border">
        <h3 className="text-lg font-semibold text-foreground">Priority Queue ({leads?.length} leads)</h3>
      </div>
      <div className="divide-y divide-border">
        {leads?.map((lead, index) => (
          <div key={lead?.id || index} className="p-4 flex items-center justify-between hover:bg-muted/30 transition-colors">
            <div className="flex items-center space-x-4">
              <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                <span className="text-sm font-bold text-primary">{index + 1}</span>
              </div>
              <div>
                <p className="font-medium text-foreground">{lead?.name || `${lead?.first_name || ''} ${lead?.last_name || ''}`?.trim() || lead?.email || 'Unknown'}</p>
                <p className="text-sm text-muted-foreground">{lead?.company || lead?.email || ''}</p>
                {lead?.insights?.length > 0 && (
                  <div className="flex flex-wrap gap-1 mt-1">
                    {lead?.insights?.slice(0, 2)?.map((insight, i) => (
                      <span key={i} className="text-xs bg-muted text-muted-foreground px-2 py-0.5 rounded">{insight}</span>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <div className="text-right">
                <p className="text-lg font-bold text-foreground">{lead?.lead_score || 0}</p>
                <span className={`text-xs px-2 py-0.5 rounded-full ${getPriorityColor(lead?.priority)}`}>
                  {lead?.priority || 'low'}
                </span>
              </div>
              <Button variant="outline" size="sm" onClick={() => onContact?.(lead?.id)}>Contact</Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PrioritizationQueue;